import { postBroadcastStop } from "@/services/api";
import { StopCircle } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function EndBroadcastContainer() {
  const [endStreamDialogOpen, setEndStreamDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const contentKey = searchParams.get("key");

  const handleEndStreamConfirm = async () => {
    try {
      setLoading(true);
      const response = await postBroadcastStop(contentKey);
      window.location.href = "/";
    } catch (error) {
      console.error("Error ending stream:", error);
      setError("Failed to end stream");
      setLoading(false);
    } finally {
      setEndStreamDialogOpen(false);
    }
  };

  return (
    <>
      <Dialog
        open={endStreamDialogOpen}
        // onClose={() => setEndStreamDialogOpen(false)}
        aria-labelledby="end-stream-dialog-title"
        aria-describedby="end-stream-dialog-description"
      >
        <DialogTitle id="end-stream-dialog-title">End Live Stream</DialogTitle>
        <DialogContent>
          <DialogContentText id="end-stream-dialog-description">
            Are you sure you want to end this live stream?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between", px: 2 }}>
          <Button
            onClick={() => setEndStreamDialogOpen(false)}
            color="info"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleEndStreamConfirm}
            color="error"
            variant="outlined"
            sx={{ borderRadius: "30px" }}
            size="small"
            autoFocus
            endIcon={loading ? <CircularProgress size={16} /> : <StopCircle />}
            disabled={loading}
          >
            End
          </Button>
        </DialogActions>
      </Dialog>

      <Button
        variant="outlined"
        size="small"
        onClick={() => setEndStreamDialogOpen(true)}
        color="error"
        endIcon={<StopCircle />}
        sx={{
          borderRadius: "30px",
          mt: 0.5,
        }}
      >
        End
      </Button>
    </>
  );
}
